import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Constants
import ROUTE from '../../constants/route-constants';

import { Action } from '../../enums/action';
import { AbilityContext } from '../Can/Can';

type PermissionRouteProps = {
  children: React.ReactNode,
  action: Action,
  page: string,
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({ children, action, page }: any) => {
  const location = useLocation();
  const ability = useContext(AbilityContext);

  if (ability.can(action, page)) return children;

  return <Navigate to={ROUTE.NOT_FOUND} state={{ from: location }} replace />;
};

export default PermissionRoute;
